export default "__VITE_ASSET__Cyj3I23T__"